import { render, staticRenderFns } from "./InspectionCreateCardLocation.vue?vue&type=template&id=e6ce62f8&scoped=true&"
import script from "./InspectionCreateCardLocation.vue?vue&type=script&lang=ts&"
export * from "./InspectionCreateCardLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ce62f8",
  null
  
)

export default component.exports